import { HTMLAttributes } from 'react';

import { StrikethroughIcon } from '@radix-ui/react-icons';
import { useEditorState, type Editor } from '@tiptap/react';

import { Toggle } from '../../../primitives/toggle';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../primitives/tooltip';

interface ToggleStrikeProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  editor: Editor;
}

export function ToggleStrike({ className, editor }: ToggleStrikeProps) {
  const { isStrike } = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      isStrike: editor.isActive('strike'),
    }),
  });

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <Toggle
            aria-label="Tachado"
            className={className}
            disabled={!editor.isEditable}
            pressed={isStrike}
            size="icon"
            variant="ghost"
            onPressedChange={() => editor.chain().focus().toggleStrike().run()}
          >
            <StrikethroughIcon className="size-4" />
          </Toggle>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="flex flex-col">
          Tachado <span className="text-accent">⌘⇧S</span>
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
